import MuiTab, { TabProps } from '@mui/material/Tab';
import MuiTabs, { TabsProps } from '@mui/material/Tabs';

const Tabs: React.FC<TabsProps> = ({
  textColor,
  indicatorColor,
  sx,
  ...props
}) => {
  const styles = !textColor &&
    !indicatorColor && {
      '&&& .MuiTabs-indicator': {
        backgroundColor: 'primary.ogSmart',
      },
      '&&& .Mui-selected': {
        color: 'primary.ogSmart',
      },
    };

  return (
    <MuiTabs
      sx={[styles, ...(Array.isArray(sx) ? sx : [sx])]}
      textColor={textColor}
      indicatorColor={indicatorColor}
      {...props}
    ></MuiTabs>
  );
};

const Tab: React.FC<TabProps> = ({ ...props }) => {
  return <MuiTab {...props}></MuiTab>;
};

export { Tabs, Tab };
